import {api} from '../api.request';

//车间生产单据监控
const get1=function(o){
   return api.get("/digitalproduction_2/get1",o)
} 
//车缝作业
const get2=function(o){
   return api.get("/digitalproduction_2/get2",o)
} 
//生产车间101组工序工时平衡表
const get3=function(o){
    return api.get("/digitalproduction_1/get3",o)
 } 

export default {
    get1,
    get2,
    get3,
}